import axios from '@/axios.js'

const state = () => ({
    gudangs: [],
    tempatPenyimpanan: {}
})

const mutations = {
    SET_GUDANGS (state, payload) {
      state.gudangs = payload
    },
    ADD_GUDANG (state, item) {
      state.gudangs.unshift(item)
    },
    UPDATE_GUDANG (state, gudang) {
      const gudangIndex = state.gudangs.findIndex((p) => p.id === gudang.id)
      Object.assign(state.gudangs[gudangIndex], gudang)
    },
    REMOVE_GUDANG (state, itemId) {
      const ItemIndex = state.gudangs.findIndex((p) => p.id === itemId)
      state.gudangs.splice(ItemIndex, 1)
    },
    SET_PENYIMPANAN (state, payload) {
      state.tempatPenyimpanan = payload
    },
}

const actions = {
  fetchGudang ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-list/gudang`)
        .then((response) => {
          commit('SET_GUDANGS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  slugGudang ({ commit }, gudang) {
    return new Promise((resolve, reject) => {
      axios.get(`/term-get-slug/gudang/${gudang}`)
        .then((response) => {
          commit('SET_PENYIMPANAN', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addGudang ({ commit }, gudang ) {
    return new Promise((resolve, reject) => {
      axios.post('/term-add', gudang)
        .then((response) => {
          commit('ADD_GUDANG', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateGudang ({ commit }, gudang) {
    return new Promise((resolve, reject) => {
      axios.post(`/term-update/${gudang.id}`, gudang)
        .then((response) => {
            commit('UPDATE_GUDANG', response.data.data)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeGudang ({ commit }, gudang) {
    return new Promise((resolve, reject) => {
      axios.delete(`/term-delete/${gudang.id}`)
        .then((response) => {
            commit('REMOVE_GUDANG', gudang.id)
            resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state,
  actions,
  mutations
}